"use client";

import DepartmentTable, { DepartmentRow } from "../components/department-table";
import { DepartmentStatusCode } from "../services/department-service";

interface ActiveDepartmentTabProps {
  rows: DepartmentRow[];
  isLoading: boolean;
  onEdit: (row: DepartmentRow) => void;
  onDeactivate: (row: DepartmentRow) => void;
  onViewDetail: (row: DepartmentRow) => void;
}

const ActiveDepartmentTab: React.FC<ActiveDepartmentTabProps> = ({
  rows,
  isLoading,
  onEdit,
  onDeactivate,
  onViewDetail,
}) => {
  const activeRows = rows.filter((r) => r.statusCode === DepartmentStatusCode.ACTIVE);

  return (
    <DepartmentTable
      rows={activeRows}
      isLoading={isLoading}
      startIndex={1}
      onEdit={onEdit}
      onDeactivate={onDeactivate}
      onViewDetail={onViewDetail}
    />
  );
};

export default ActiveDepartmentTab;
